"use client";

// ReactToastifyContext هسته CSS کتابخانه (~۱۴KB) را در بالای فایل import می‌کند و چون در layout است، آن CSS روی
// همه‌ی صفحه‌ها رندر را بلاک می‌کرد. container فقط در مرورگر و جدا لود می‌شود؛ react-toastify ۱۰ پیام‌هایی را که
// قبل از mount شدن container فرستاده شوند در صف نگه می‌دارد و بعد نشان می‌دهد، پس پیامی گم نمی‌شود.
import dynamic from "next/dynamic";

const ToastContainerLazy = dynamic(
  () => import("@core/helpers/client/contexts/ReactToastifyContext").then((m) => m.ReactToastifyContextProvider),
  { ssr: false }
);

export default ToastContainerLazy;
